<div class="ce-page">
  <header class="ce-page__header">
    <div class="ce-page__brand">
      <img src="assets/images/logo.svg" alt="Nest Builder" class="ce-page__logo" />
    </div>
  </header>

  <main class="ce-page__content">
    <h1 class="ce-page__heading">ROI Calculator</h1>

    <div class="ce-layout">
    <section class="ce-card ce-card--inputs">
      <h2 class="ce-card__title">Inputs</h2>

      <div class="ce-form">
        <label class="ce-form__field">
          <span class="ce-form__label">Number of leads purchased</span>
          <input
            type="number"
            min="0"
            [(ngModel)]="numberOfLeads"
            class="ce-form__input"
          />
        </label>

        <label class="ce-form__field">
          <span class="ce-form__label">Cost per lead ($)</span>
          <input
            type="number"
            min="0"
            [(ngModel)]="costPerLead"
            class="ce-form__input"
          />
        </label>

        <label class="ce-form__field">
          <span class="ce-form__label">Close rate (%)</span>
          <input
            type="number"
            min="0"
            max="100"
            [(ngModel)]="closeRatePercent"
            class="ce-form__input"
          />
        </label>

        <label class="ce-form__field">
          <span class="ce-form__label">Gross profit per job ($)</span>
          <input
            type="number"
            min="0"
            [(ngModel)]="grossProfitPerJob"
            class="ce-form__input"
          />
        </label>
      </div>
    </section>

    <section class="ce-card ce-card--results">
      <h2 class="ce-card__title">Results</h2>

      <div class="ce-results">
        <div class="ce-results__row">
          <span class="ce-results__label">Total lead spend</span>
          <span class="ce-results__value">
            $ {{ totalLeadSpend | number: '1.2-2' }}
          </span>
        </div>

        <div class="ce-results__row">
          <span class="ce-results__label">Jobs won</span>
          <span class="ce-results__value">
            {{ jobsWon | number: '1.0-0' }}
          </span>
        </div>

        <div class="ce-results__row">
          <span class="ce-results__label">Total gross profit</span>
          <span class="ce-results__value">
            $ {{ totalGrossProfit | number: '1.2-2' }}
          </span>
        </div>

        <div class="ce-results__row">
          <span class="ce-results__label">Net profit after lead cost</span>
          <span class="ce-results__value ce-results__value--highlight">
            $ {{ netProfitAfterLeadCost | number: '1.2-2' }}
          </span>
        </div>

        <div class="ce-results__row">
          <span class="ce-results__label">Cost per closed job</span>
          <span class="ce-results__value">
            $ {{ costPerClosedJob | number: '1.2-2' }}
          </span>
        </div>

        <div class="ce-results__row">
          <span class="ce-results__label">Return on lead spend</span>
          <span class="ce-results__value">
            {{ returnOnLeadSpend | number: '1.2-2' }}
          </span>
        </div>

        <div class="ce-results__row">
          <span class="ce-results__label">Revenue multiple (per $1 spent)</span>
          <span class="ce-results__value">
            {{ revenueMultiple | number: '1.2-2' }}
          </span>
        </div>
      </div>
    </section>
    </div>
  </main>
</div>

